import { useFetchClient } from '~/api/fetch-client'
import * as auth from '~/api/services/auth'
import * as licenses from '~/api/services/licenses'
import * as permissions from '~/api/services/permissions'
import * as assets from '~/api/services/assets'
import * as localization from '~/api/services/localization'
import * as mapbox from '~/api/services/mapbox'
import * as locations from '~/api/services/locations'
import * as groups from '~/api/services/groups'
import * as configurationPresets from '~/api/services/configurationPresets'
import * as actions from '~/api/services/actions'
import * as alerts from '~/api/services/alerts'
import * as filters from '~/api/services/filters'
import * as routes from '~/api/services/routes'
import * as schedules from '~/api/services/schedules'
import * as reports from '~/api/services/reports'
import * as reportService from '~/api/services/report-service'
import * as users from '~/api/services/users'
import * as licenceUsers from '~/api/services/licence-users'
import * as beacon from '~/api/services/beacon'
import * as plugins from '~/api/services/plugins'
import * as stateViewConfigs from '~/api/services/stateViewConfigs'
import { createEndpointsRegistry } from '~/api/registry'
import { gatewayEndpointsConfig } from '~/api/endpoints/gateway-endpoints'
import { reportServiceEndpointsConfig } from '~/api/endpoints/report-service-endpoints'
import { oauthEndpointsConfig } from '~/api/endpoints/oauth-endpoints'
import { mapboxEndpointsConfig } from '~/api/endpoints/mapbox-endpoints'
import type { API } from '~/api/types'

export const useApi = (): API => {
  const client = useFetchClient()
  const config = useRuntimeConfig().public
  const serverUrl = config.apiUrl
  const oauthServerUrl = config.oauthServerUrl
  const mapboxServerUrl = config.mapboxServerUrl

  const gatewayRegistry = createEndpointsRegistry(serverUrl, gatewayEndpointsConfig)
  const reportServiceRegistry = createEndpointsRegistry(`${serverUrl}/v2`, reportServiceEndpointsConfig)
  const oAuthRegistry = createEndpointsRegistry(oauthServerUrl, oauthEndpointsConfig)
  const mapboxRegistry = createEndpointsRegistry(mapboxServerUrl, mapboxEndpointsConfig)

  return {
    $fetch: client,
    auth: auth.registerEndpoints(client, oAuthRegistry),
    licenses: licenses.registerEndpoints(client, gatewayRegistry),
    permissions: permissions.registerEndpoints(client, gatewayRegistry),
    assets: assets.registerEndpoints(client, gatewayRegistry),
    localization: localization.registerEndpoints(client, gatewayRegistry),
    mapbox: mapbox.registerEndpoints(client, mapboxRegistry),
    locations: locations.registerEndpoints(client, gatewayRegistry),
    groups: groups.registerEndpoints(client, gatewayRegistry),
    configurationPresets: configurationPresets.registerEndpoints(client, gatewayRegistry),
    alerts: alerts.registerEndpoints(client, gatewayRegistry),
    filters: filters.registerEndpoints(client, gatewayRegistry),
    actions: actions.registerEndpoints(client, gatewayRegistry),
    routes: routes.registerEndpoints(client, gatewayRegistry),
    schedules: schedules.registerEndpoints(client, gatewayRegistry),
    reports: reports.registerEndpoints(client, gatewayRegistry),
    reportService: reportService.registerEndpoints(client, reportServiceRegistry),
    users: users.registerEndpoints(client, gatewayRegistry),
    licenceUsers: licenceUsers.registerEndpoints(client, gatewayRegistry),
    beacon: beacon.registerEndpoints(client, gatewayRegistry),
    plugins: plugins.registerEndpoints(client, gatewayRegistry),
    stateViewConfigs: stateViewConfigs.registerEndpoints(client, gatewayRegistry)
  }
}
